import { useState } from 'react'

import { faHistory } from '@fortawesome/pro-regular-svg-icons'
import { Box, Button, List } from '@material-ui/core'
import { isEmpty, map } from 'lodash'

import { FocusDropdownTitle } from 'components/AwesomeBar'

import LinkListItem from '../../LinkListItem'
import { SCID_MATCH, TAG } from '../../constants'
import ResultComponent from '../../use-search-configurations/search-colleges/ResultComponent'
import { useOnClear } from './use-on-clear'
import { useRecentSearches } from './use-recent-searches'

interface IRecentProps {
  open: boolean
  onCloseFocusDropdown: () => void
}

interface IHistoricalItem {
  to: string
  label: string
  hoverText: string
  type: string
  scid: number
  name: string
  city: string
  state: string
  listItemProps?: object
}

const HistoricalTagResult = (props: IHistoricalItem): JSX.Element => {
  return (
    <LinkListItem
      to={props.to}
      label={props.label}
      hoverText={props.hoverText}
      icon={faHistory}
      button
      disableGutters={false}
      style={{
        padding: '8px 16px',
      }}
      {...props.listItemProps}
    />
  )
}

const RESULT_COMPONENTS = {
  [SCID_MATCH]: ResultComponent,
  [TAG]: HistoricalTagResult,
}

const Recent = ({ open, onCloseFocusDropdown }: IRecentProps) => {
  const [historicalResults, setHistoricalResults] = useState<IHistoricalItem[]>([])
  const recentSearches = useRecentSearches({ open, historicalResults, setHistoricalResults })
  const onClear = useOnClear(setHistoricalResults)

  return isEmpty(recentSearches) ? null : (
    <List>
      <FocusDropdownTitle>
        <Box
          width="100%"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          Recent
          <Button
            color="primary"
            onClick={() => onClear()}
          >
            Clear
          </Button>
        </Box>
      </FocusDropdownTitle>
      {!open
        ? null
        : map(recentSearches, (result, index) => {
            const resultType = result.type as typeof SCID_MATCH | typeof TAG
            const Comp = RESULT_COMPONENTS[resultType]
            return (
              <Comp
                key={index}
                {...result}
                listItemProps={{
                  button: true,
                  style: { padding: '8px 16px' },
                  onClick: onCloseFocusDropdown,
                }}
              />
            )
          })}
    </List>
  )
}

export default Recent
